<template>
  <div class="main-department">

    <main>
      <header>
        <h3>部门管理</h3>
        <!-- <span>/ computer management</span> -->
        <div class="btn-group">
          <a-button v-if="$IA('system:org:save')" type="primary" icon="plus" @click="handleOpen('添加')"
          >添加</a-button
          >
        </div>
      </header>

      <!-- 数据表格 -->
      <a-table
        v-if="tableData && tableData.length"
        :columns="tableColumns"
        :data-source="tableData"
        rowKey="id"
        bordered
        :pagination="false"
        :loading="tableLoad"
        :scroll="{ y: 670 }"
        @change="handleTableChange"
        :defaultExpandAllRows="true"
        style="margin-top: 16px"
      >
        <span slot="customTitle">名称</span>
        <span slot="action" slot-scope="text, record" class="table-action-box">
            <a-tooltip  content="" v-if="$IA('system:org:update') && !record.disabled" title="修改" placement="top" effect="light">
              <i class="table-edit"  @click="handleOpen('修改',record)" ></i>
            </a-tooltip>
            <a-tooltip  content="" v-if="$IA('system:org:delete')&& !record.disabled" title="删除" placement="top" effect="light">
              <i class="table-delected"  @click="handleOpen('删除',record)" ></i>
            </a-tooltip>
        </span>
      </a-table>
      <div class="default_img" v-else>
        <div class="nothing-data">
        </div>
        <p style="margin-bottom: 60px;">暂无数据</p>
      </div>
    </main>

    <!-- 添加 -->
    <a-modal
      centered
      :title="modalTitle+'部门'"
      :visible="modalVisible"
      :confirm-loading="submitLoad"
      @ok="handleOk('deptForm')"
      width="580px"
      @cancel="resetForm"
      :maskClosable="false"
      :width="modalTitle == '删除' ? '420px' : '520px'"
    >
      <a-form-model
        v-if="['添加', '修改'].includes(modalTitle)"
        layout="vertical"
        :model="deptForm"
        :rules="deptRules"
        ref="deptForm"
      >
        <a-form-model-item  prop="id" v-show="false">
             <a-input v-model="deptForm.id" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="上级部门" prop="parentId" v-if=" modalTitle == '添加' ">
          <a-tree-select
              v-model='deptForm.parentId'
              style="width: 100%"
              allowClear
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="treeData"
              placeholder="选择部门"
              show-search
              :filterTreeNode="filter_tree_node"
              tree-default-expand-all
              :replaceFields="{ title: 'name', key: 'id',value:'id' }"
          >
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item label="上级部门" prop="parentId" v-if="( modalTitle == '修改' && this.deptForm.parentId != '') "
        :rules="{ required: true, message: '上级部门不能为空', trigger: 'blur' }"
        >
          <a-tree-select
            v-model='deptForm.parentId'
            style="width: 100%"
            allowClear
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="treeData"
            placeholder="选择部门"
            tree-default-expand-all
            :replaceFields="{ title: 'name', key: 'id',value:'id' }"
          >
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item label="部门名称" prop="name">
          <a-input v-model="deptForm.name" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="描述" prop="description">
          <a-input v-model="deptForm.description" placeholder="请输入" />
        </a-form-model-item>
        <template slot="footer">
          <a-button key="back" @click="modalVisible = false"> 取消 </a-button>
          <a-button
            key="submit"
            :loading="btnLoad"
            type="primary"
            @click="handleOk"
          >
            提交
          </a-button>
        </template>
      </a-form-model>

      <div class="deleteBox" v-if="modalTitle == '删除'">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>此操作将永久删除该部门,是否继续?</p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {notification} from "ant-design-vue";

export default {
  data() {
    return {
      btnLoad: false,
      tableLoad: false,
      submitLoad:false,
      pagination: {
        searchText: "",
        pageSize: 10,
      },
      tableColumns: [
        {
          width: 220,
          dataIndex: "name",
          key: "name",
          slots: { title: "customTitle" },
          scopedSlots: { customRender: "name" },
        },
        {
          title: "描述",
          dataIndex: "description",
          key: "description",
          ellipsis: true
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          key: "createTime",
        },
        {
          title: "更新时间",
          dataIndex: "updateTime",
          key: "updateTime",
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
          align: "center",
          width: 100,
        },
      ],
      tableData: [],
      // 模态框显隐
      modalVisible: false,
      // 模态框标题
      modalTitle: "",
      // 上级部门下拉
      treeData:[],
      // 单行数据
      singleDta:"",
      saveApi: "", // 添加/修改保存API
      // 添加表单
      deptForm: {
        id:"",
        name: "",
        parentId: undefined,
        description: "",
      },
      deptRules: {
        name: [{ required: true, max: 20, message: "部门名称最长不能超过20字符且不可为空" }],
        description: [{ required: false, max: 250, message: "描述最长不能超过250字符" }],
      },
    };
  },
  methods: {
    // 部门筛选
    filter_tree_node( input,node ) {
      if ( node.children == null ) {
        if ( node.componentOptions.propsData.title.indexOf( input ) !=-1 ) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 重置表单通用方法
    resetForm() {
      if (this.modalTitle =='添加' ||this.modalTitle =='修改' ) {
          this.$refs.deptForm.resetFields()
      }
      this.modalVisible = false
    },
    // 初始化部门
    orgInitialization(){
      this.btnLoad = true
      this.axios
          .get("/org/generateClosure")
          .then((res) => {
            this.btnLoad = false;
            if (res.code === 200) {
              notification.success({
                message: '初始化成功',
                duration: 3,
                customClass: "batch-import",
              })
              this.handleTableChange();
            }
          })
          .catch((err) => {
            this.btnLoad = false;
            console.log(err);
          });
    },
    // 打开模态框
    handleOpen(title,data) {
      this.modalTitle = title;
      this.modalVisible = true;
      this.$nextTick(()=>{
        this.singleDta = data
        switch (title) {
          case '添加':
            this.saveApi = '/org/save'
            this.deptForm.parentId = undefined
            this.superiorOrgSelect();

            break;
          case '修改':
            this.saveApi = '/org/update'
            this.deptForm = this.$lodash.pick(
              this.singleDta,
              this.$lodash.keys(this.deptForm)
            );
            this.axios
                .post("org/findCurrentOrgList/" + this.deptForm.id )
                .then((res) => {
                  // console.log(res.data);
                  if (res.code === 200) {
                    this.treeData = res.data;
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            break;
          case '删除':
            break;
        }
      })
    },
    // 确认模态框
    handleOk(formName) {
     if (this.modalTitle == "添加" || this.modalTitle == "修改") {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitLoad = true;
            let saveData = "";
            saveData = this.$lodash.cloneDeep(this.deptForm);
            this.axios
              .post(this.saveApi, saveData)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  this.resetForm();
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                  this.handleTableChange();
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
        this.submitLoad = true;
        this.axios
          .delete("/org/delete/" + this.singleDta.id)
          .then((res) => {
            this.submitLoad = false;
            if (res.code === 200) {
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
              this.handleTableChange();
              this.modalVisible = false;
            }
          })
          .catch((err) => {
            this.submitLoad = false;
            console.log(err);
          });
      }
    },
    // 部门下拉框
    superiorOrgSelect() {
      this.axios
        .post("org/findPage")
        .then((res) => {
          // console.log(res.data);
          if (res.code === 200) {
            this.treeData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 搜索
    searchChange(v) {
      this.pagination.pageNo = 1;
      if (window.searchTimer) {
        clearTimeout(window.searchTimer);
      }
      window.searchTimer = setTimeout(this.handleTableChange, 1000);
    },
    // 翻页请求
    handleTableChange(pagination, filters, sorter) {
      this.tableLoad = true;
      this.axios
        .post("/org/findOrg", this.$qs.stringify(this.pagination))
        .then((res) => {
          if (res.code === 200) {
            this.tableLoad = false;
            this.tableData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoad = false;
        });
    },
  },
  beforeMount() {
    this.handleTableChange();
  },
};
</script>

<style lang="scss" scoped>
.main-department {

  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;
    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }
    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;

          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }

  }
}
</style>
